import React, { useEffect, useRef } from 'react';

const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const asset = (name) => `${pub}/advisory-board/${name}`;

const S = {
  serif: 'New Spirit, Georgia, serif',
  sans:  'GT Walsheim, Calibri, Inter, sans-serif',
  logo:  'Josefin Sans, Lato, sans-serif',
};

const C = {
  teal:    '#004B49',
  deepTeal:'#003332',
  bronze:  '#EB926E',
  gold:    '#CFAF5B',
  goldSoft:'#FFF9F0',
  platinum:'#E5E4E2',
  tealLite:'#E6F0F0',
  fgMuted: '#4A5A5A',
};

const resources = {
  glyph:     asset('glyph.svg'),
  logoHoriz: asset('logoHoriz.png'),
  pJohn:     asset('pJohn.jpg'),
  pMaggie:   asset('pMaggie.jpg'),
  pDerek:    asset('pDerek.jpg'),
  pKristina: asset('pKristina.jpg'),
  pTaylor:   asset('pTaylor.jpg'),
  pMike:     asset('pMike.jpg'),
  pBuxton:   asset('pBuxton.jpg'),
  pNate:     asset('pNate.png'),
};

const FooterBar = ({ pageOf }) => (
  <div style={{
    position:'absolute', left:120, right:120, bottom:50,
    display:'flex', justifyContent:'space-between', alignItems:'center',
    fontFamily:S.sans, fontSize:14, letterSpacing:'0.18em', textTransform:'uppercase',
    color:'rgba(0,75,73,0.55)',
    paddingTop:18, borderTop:'1px solid rgba(0,75,73,0.12)'
  }}>
    <span>Helmsman Imports &nbsp;·&nbsp; Advisory Board &nbsp;·&nbsp; Internal</span>
    <span>{pageOf}</span>
  </div>
);

const FooterBarDark = ({ pageOf }) => (
  <div style={{
    position:'absolute', left:120, right:120, bottom:50,
    display:'flex', justifyContent:'space-between', alignItems:'center',
    fontFamily:S.sans, fontSize:14, letterSpacing:'0.18em', textTransform:'uppercase',
    color:'rgba(255,255,255,0.45)',
    paddingTop:18, borderTop:'1px solid rgba(255,255,255,0.15)'
  }}>
    <span>Helmsman Imports &nbsp;·&nbsp; Advisory Board &nbsp;·&nbsp; Internal</span>
    <span>{pageOf}</span>
  </div>
);

function S01_Title() {
  return (
    <section style={{width:'100%',height:'100%',background:C.teal,color:'#fff',padding:'110px 140px',position:'relative',overflow:'hidden',boxSizing:'border-box'}}>
      <svg viewBox="0 0 1920 1080" preserveAspectRatio="none"
           style={{position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none'}}>
        <defs>
          <linearGradient id="t1Gold" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor={C.gold} stopOpacity="0"/>
            <stop offset="0.5" stopColor={C.gold} stopOpacity="0.55"/>
            <stop offset="1" stopColor={C.gold} stopOpacity="0.85"/>
          </linearGradient>
          <linearGradient id="t1White" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#fff" stopOpacity="0"/>
            <stop offset="0.5" stopColor="#fff" stopOpacity="0.18"/>
            <stop offset="1" stopColor="#fff" stopOpacity="0.32"/>
          </linearGradient>
        </defs>
        <line x1="140" y1="980" x2="1780" y2="980" stroke={C.gold} strokeOpacity="0.25" strokeWidth="1"/>
        {[1700,2050,2400,2750,3100,3450].map((r,i)=>(
          <circle key={r} cx="1920" cy="1080" r={r} fill="none"
                  stroke={i===2?'url(#t1Gold)':'url(#t1White)'}
                  strokeWidth={i===2?1.5:1}
                  strokeOpacity={i===2?1:(0.9 - i*0.12)}/>
        ))}
        <path d="M -50 940 Q 480 880 960 940 T 1970 940" fill="none" stroke={C.gold} strokeOpacity="0.35" strokeWidth="1.25"/>
        <path d="M -50 970 Q 480 920 960 970 T 1970 970" fill="none" stroke="#fff" strokeOpacity="0.10" strokeWidth="1"/>
        <g transform="translate(1560 560)" opacity="0.85">
          <circle r="420" fill="none" stroke={C.gold} strokeOpacity="0.10" strokeWidth="1"/>
          <circle r="360" fill="none" stroke={C.gold} strokeOpacity="0.18" strokeWidth="1"/>
          <circle r="300" fill="none" stroke={C.gold} strokeOpacity="0.32" strokeWidth="1.25"/>
          <g fill="none" stroke={C.gold} strokeOpacity="0.55" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle r="230"/>
            <circle r="52" fill={C.gold} fillOpacity="0.7" stroke="none"/>
            <line x1="0" y1="-230" x2="0" y2="-330"/>
            <line x1="0" y1="230" x2="0" y2="330"/>
            <line x1="-230" y1="0" x2="-330" y2="0"/>
            <line x1="230" y1="0" x2="330" y2="0"/>
            <line x1="-163" y1="-163" x2="-235" y2="-235"/>
            <line x1="163" y1="-163" x2="235" y2="-235"/>
            <line x1="-163" y1="163" x2="-235" y2="235"/>
            <line x1="163" y1="163" x2="235" y2="235"/>
          </g>
          <g stroke="none">
            <polygon points="0,-220 22,0 0,220 -22,0" fill={C.gold} fillOpacity="0.42"/>
            <polygon points="-220,0 0,22 220,0 0,-22" fill={C.gold} fillOpacity="0.28"/>
          </g>
          <text x="0" y="-360" textAnchor="middle"
                fontFamily={S.sans} fontSize="26" fontWeight="500" letterSpacing="6"
                fill={C.gold} fillOpacity="0.85">N</text>
        </g>
      </svg>

      <div style={{position:'relative', height:'100%', display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
          <img src={resources.logoHoriz} alt="Helmsman" style={{height:78, width:'auto', objectFit:'contain', filter:'brightness(0) invert(1)', display:'block'}}/>
          <div style={{fontFamily:S.sans, fontSize:14, letterSpacing:'0.28em', textTransform:'uppercase', color:'rgba(255,255,255,0.55)', textAlign:'right', lineHeight:1.6}}>
            Internal &nbsp;·&nbsp; For the Helmsman team<br/>
            Not for distribution
          </div>
        </div>

        <div>
          <div style={{fontFamily:S.sans, fontSize:24, letterSpacing:'0.32em', textTransform:'uppercase', color:C.gold, marginBottom:48, fontWeight:500}}>
            Team rollout &nbsp;·&nbsp; April 2026
          </div>
          <h1 style={{fontFamily:S.serif, fontSize:200, lineHeight:0.92, fontWeight:600, letterSpacing:'-0.02em', margin:'0 0 44px', maxWidth:1700, color:'#fff'}}>
            Meet our<br/>Advisory Board.
          </h1>
          <div style={{fontFamily:S.serif, fontSize:48, color:'rgba(255,255,255,0.88)', maxWidth:1500, lineHeight:1.25, fontStyle:'italic'}}>
            Seven people. Seven stories. This is who said yes to us — and why.
          </div>
          <div style={{marginTop:56, paddingTop:22, borderTop:`1px solid ${C.gold}`, maxWidth:880, display:'flex', gap:22, alignItems:'flex-start'}}>
            <div style={{fontFamily:S.sans, fontSize:12, letterSpacing:'0.34em', textTransform:'uppercase', color:C.gold, fontWeight:500, lineHeight:1.6, whiteSpace:'nowrap'}}>
              Our compass
            </div>
            <div style={{fontFamily:S.serif, fontSize:22, color:'rgba(255,255,255,0.78)', lineHeight:1.5, fontStyle:'italic'}}>
              We built the compass to steer by. These seven help us read it.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function S02_Letter() {
  return (
    <section style={{width:'100%',height:'100%',background:C.goldSoft,color:'#000',padding:'100px 140px',position:'relative',boxSizing:'border-box',display:'grid',gridTemplateColumns:'380px 1fr',gap:80}}>
      <div style={{borderTop:`4px solid ${C.gold}`, paddingTop:32}}>
        <div style={{fontFamily:S.sans, fontSize:14, letterSpacing:'0.28em', textTransform:'uppercase', color:'#7a6528', marginBottom:40}}>A note from Jeff</div>
        <div style={{fontFamily:S.serif, fontSize:72, lineHeight:1.02, fontWeight:600, color:C.teal, letterSpacing:'-0.02em'}}>
          <span style={{fontSize:96, lineHeight:0.8, display:'inline-block', marginRight:6, verticalAlign:'-0.05em', color:C.gold, fontStyle:'italic'}}>"</span>Be proud of this.
          <div style={{marginTop:28, fontStyle:'italic', color:C.bronze, fontSize:40, fontWeight:500, lineHeight:1.2, letterSpacing:'-0.01em'}}>
            Say it with me:<br/>I am proud of myself.
          </div>
        </div>
        <div style={{marginTop:60, fontFamily:S.sans, fontSize:16, color:C.fgMuted, lineHeight:1.7}}>
          Jeff Diego<br/>
          <span style={{color:C.teal, fontWeight:500}}>Founder &amp; CEO, Helmsman Imports</span>
        </div>
      </div>

      <div style={{fontFamily:S.sans, fontSize:24, lineHeight:1.6, color:'#1a2624', maxWidth:980, alignSelf:'center'}}>
        <p style={{margin:'0 0 26px'}}>Before you meet the seven people in the next pages, I wanted to write to you directly.</p>
        <p style={{margin:'0 0 26px'}}>Over the next few weeks, we'll be announcing our Advisory Board. The work we've all been doing is being noticed by people who would not have taken our call two years ago. We are part of the conversation now.</p>
        <p style={{margin:'0 0 26px'}}>I didn't grow up in this industry, or in this country. So when people of this caliber choose to sit at our table, I don't take it lightly — and I don't take lightly what it has cost each of you to get us here: the late nights, the missed weekends, the patience with a company that was still figuring itself out.</p>
        <p style={{margin:'0 0 26px'}}>These advisors are good people who chose to back us. They'll help us make better decisions and avoid expensive mistakes. I don't know exactly what they saw in us — but whatever it is, we have to keep being it. When people see our work, they're inspired by it. That is not a small thing.</p>
        <p style={{margin:'0 0 26px'}}>I hope working at Helmsman is meaningful for you. The kind of organization I'm trying to build is one that people are proud to work in, and proud to work with.</p>
        <p style={{margin:'0 0 26px'}}>Thank you, genuinely.</p>
        <p style={{margin:'16px 0 0', fontFamily:S.serif, fontSize:30, color:C.teal, fontWeight:500, fontStyle:'italic'}}>— Jeff</p>
      </div>

      <FooterBar pageOf="02 / 12"/>
    </section>
  );
}

function S03_Framing() {
  const lanes = [
    {
      label:'Reach',
      head:'Doors we cannot knock on alone.',
      body:'Managing-Director-level relationships across SGWS, Breakthru, RNDC, and Diageo. Decisions that used to take six months now happen in a phone call.',
      tags:["Southern Glazer's", 'Breakthru', 'RNDC', 'Diageo', 'Pernod Ricard', 'Keurig Dr Pepper'],
      brands:'Johnnie Walker · Don Julio · Jose Cuervo · Dr Pepper · 7UP · Snapple · Mr Black · Stolen Rum · BeatBox',
    },
    {
      label:'Judgment',
      head:'Stress-test before we bet.',
      body:'Seven operators who have already sat in the seat we are about to sit in. Every major commercial decision now gets a sanity check from someone who has lived the consequences.',
      tags:['Three-time exited founders', 'P&L CEOs ($500M+)', 'Distributor operators', 'Capital-markets structurers', 'PR & industry press'],
    },
    {
      label:'Speed',
      head:'Years compressed into weeks.',
      body:'Distribution, brand-building, exits, capital, PR. Every lane has someone who has run the playbook before, so we stop reinventing it.',
      tags:['3-tier distribution', 'Chain accounts', 'Exit to strategic', 'Inventory-backed debt', 'Trade & consumer PR', 'Wine & spirits supply'],
    },
  ];
  return (
    <section style={{width:'100%',height:'100%',background:'#fff',color:'#000',padding:'60px 110px 100px',position:'relative',boxSizing:'border-box',display:'flex', flexDirection:'column'}}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${C.platinum}`}}>
        <div style={{display:'flex', alignItems:'baseline', gap:32}}>
          <div style={{fontFamily:S.sans, fontSize:14, letterSpacing:'0.34em', textTransform:'uppercase', color:C.teal, fontWeight:500}}>Before you meet them</div>
          <div style={{fontFamily:S.serif, fontSize:32, color:C.teal, fontStyle:'italic', fontWeight:500, letterSpacing:'-0.01em'}}>
            What this board changes for us.
          </div>
        </div>
        <div style={{fontFamily:S.sans, fontSize:13, letterSpacing:'0.24em', textTransform:'uppercase', color:C.fgMuted}}>Three things · concretely</div>
      </div>

      <div style={{flex:1, display:'flex', flexDirection:'column'}}>
        {lanes.map((l, i)=>{
          const isLast = i === lanes.length - 1;
          return (
            <div key={l.label} style={{
              flex:1, display:'grid', gridTemplateColumns:'560px 1fr 440px',
              gap:52, alignItems:'center', padding:'22px 0',
              borderBottom: isLast ? 'none' : `1px solid ${C.platinum}`,
              position:'relative',
            }}>
              <div style={{position:'relative'}}>
                <div style={{position:'absolute', top:-2, left:0, fontFamily:S.serif, fontSize:36, color:C.bronze, fontWeight:600, letterSpacing:'-0.02em', lineHeight:1}}>0{i+1}</div>
                <div style={{fontFamily:S.serif, fontSize:132, fontWeight:600, lineHeight:0.9, letterSpacing:'-0.04em', color:C.teal, paddingLeft:70}}>
                  {l.label === 'Judgment'
                    ? <>Judg<span style={{color:C.bronze,fontStyle:'italic'}}>ment</span><span style={{color:C.gold}}>.</span></>
                    : <>{l.label}<span style={{color:C.gold}}>.</span></>
                  }
                </div>
              </div>
              <div>
                <div style={{fontFamily:S.serif, fontSize:36, fontWeight:600, lineHeight:1.1, color:C.teal, letterSpacing:'-0.015em', marginBottom:14}}>{l.head}</div>
                <div style={{fontFamily:S.sans, fontSize:19, color:'#1a2624', lineHeight:1.55, maxWidth:560}}>{l.body}</div>
              </div>
              <div>
                <div style={{display:'flex', flexWrap:'wrap', gap:'6px'}}>
                  {l.tags.map((t, ti)=>(
                    <span key={ti} style={{fontFamily:S.sans, fontSize:12, fontWeight:500, color:C.teal, background:C.tealLite, padding:'5px 10px', border:`1px solid rgba(0,75,73,0.15)`, lineHeight:1.3}}>{t}</span>
                  ))}
                </div>
                {l.brands && (
                  <div style={{marginTop:12, paddingTop:10, borderTop:`1px dashed ${C.platinum}`}}>
                    <div style={{fontFamily:S.serif, fontSize:13, color:C.fgMuted, lineHeight:1.45, fontStyle:'italic'}}>{l.brands}</div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <FooterBar pageOf="03 / 12"/>
    </section>
  );
}

function PersonSlide({ index, of, lane, name, title, photo, why, bring, engage, pageOf, companies, companiesNote, accent='teal', bgVariant='white', photoScale=1, photoPosition='center 25%' }) {
  const eyebrowColor = accent === 'bronze' ? C.bronze : (accent === 'gold' ? '#7a6528' : C.teal);
  const bg = bgVariant === 'cream' ? C.goldSoft : '#fff';

  return (
    <section style={{width:'100%',height:'100%',background:bg,color:'#000',position:'relative',boxSizing:'border-box',display:'grid',gridTemplateColumns:'820px 1fr', overflow:'hidden'}}>
      <div style={{position:'relative', background:C.deepTeal, color:'#fff', display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:'80px 70px 80px', overflow:'hidden'}}>
        <div style={{position:'absolute', inset:0, overflow:'hidden'}}>
          <img src={photo} alt={name}
               style={{width:'100%', height:'100%', objectFit:'cover', objectPosition:photoPosition, filter:'saturate(0.92) contrast(1.02)', transform:`scale(${photoScale})`, transformOrigin:'center top'}}/>
          <div style={{position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(0,51,50,0) 35%, rgba(0,51,50,0.55) 70%, rgba(0,51,50,0.95) 100%)'}}/>
          <div style={{position:'absolute', top:0, left:0, right:0, padding:'40px 70px', display:'flex', justifyContent:'space-between', alignItems:'center', background:'linear-gradient(180deg, rgba(0,51,50,0.85) 0%, rgba(0,51,50,0) 100%)'}}>
            <div style={{display:'flex', alignItems:'baseline', gap:18}}>
              <span style={{fontFamily:S.serif, fontSize:42, fontWeight:600, color:C.gold, letterSpacing:'-0.02em', lineHeight:1}}>{String(index).padStart(2,'0')}</span>
              <span style={{fontFamily:S.sans, fontSize:14, letterSpacing:'0.28em', textTransform:'uppercase', color:'rgba(255,255,255,0.78)'}}>of {String(of).padStart(2,'0')} &nbsp;·&nbsp; advisor</span>
            </div>
            <span style={{fontFamily:S.sans, fontSize:13, letterSpacing:'0.22em', textTransform:'uppercase', color:'rgba(255,255,255,0.72)', borderLeft:`2px solid ${C.gold}`, paddingLeft:14, maxWidth:340, textAlign:'right', lineHeight:1.3}}>
              {lane}
            </span>
          </div>
        </div>
        <div style={{position:'relative'}}>
          <div style={{borderTop:`3px solid ${C.gold}`, width:90, marginBottom:24}}/>
          <h2 style={{fontFamily:S.serif, fontSize:84, lineHeight:0.94, fontWeight:600, letterSpacing:'-0.02em', margin:'0 0 24px', color:'#fff'}}>{name}</h2>
          <div style={{fontFamily:S.sans, fontSize:22, lineHeight:1.5, color:'rgba(255,255,255,0.92)', maxWidth:660}}>{title}</div>
        </div>
      </div>

      <div style={{padding:'70px 90px 180px', display:'flex', flexDirection:'column', gap:32, position:'relative', overflow:'hidden'}}>
        <div>
          <div style={{display:'flex', alignItems:'center', gap:14, marginBottom:18}}>
            <div style={{width:32, height:1, background:eyebrowColor}}/>
            <div style={{fontFamily:S.sans, fontSize:15, letterSpacing:'0.32em', textTransform:'uppercase', color:eyebrowColor, fontWeight:500}}>Background</div>
          </div>
          <div style={{fontFamily:S.sans, fontSize:25, lineHeight:1.5, color:'#1a2624', maxWidth:960}}>{why}</div>
        </div>

        <div>
          <div style={{display:'flex', alignItems:'center', gap:14, marginBottom:18}}>
            <div style={{width:32, height:1, background:eyebrowColor}}/>
            <div style={{fontFamily:S.sans, fontSize:15, letterSpacing:'0.32em', textTransform:'uppercase', color:eyebrowColor, fontWeight:500}}>What they bring</div>
          </div>
          <div style={{display:'flex', flexDirection:'column', gap:0}}>
            {bring.map((b, i)=>(
              <div key={i} style={{display:'grid', gridTemplateColumns:'60px 1fr', alignItems:'baseline', padding:'18px 0', borderTop: i===0 ? 'none' : `1px solid ${C.platinum}`}}>
                <div style={{fontFamily:S.serif, fontSize:28, fontWeight:600, color:C.bronze, letterSpacing:'-0.01em'}}>{String(i+1).padStart(2,'0')}</div>
                <div style={{fontFamily:S.sans, fontSize:23, lineHeight:1.45, color:'#000'}}>{b}</div>
              </div>
            ))}
          </div>
        </div>

        {companies && (
          <div style={{position:'absolute', left:90, right:90, bottom:90, paddingTop:18, borderTop:`2px solid ${C.gold}`}}>
            <div style={{marginBottom:10}}>
              <div style={{fontFamily:S.sans, fontSize:13, letterSpacing:'0.3em', textTransform:'uppercase', color:'#7a6528', fontWeight:500, marginBottom:10}}>Notable companies</div>
              <div style={{display:'flex', flexWrap:'wrap', gap:'6px 28px', fontFamily:S.serif, lineHeight:1.2}}>
                {companies.map((c, i) => {
                  const [nm, val] = Array.isArray(c) ? c : [c, null];
                  return (
                    <div key={i} style={{display:'flex', alignItems:'baseline', gap:10}}>
                      <span style={{fontSize:26, color:C.teal, fontWeight:600, letterSpacing:'-0.01em'}}>{nm}</span>
                      {val && <span style={{fontFamily:S.sans, fontSize:14, color:C.bronze, fontWeight:500, letterSpacing:'0.02em'}}>{val}</span>}
                      {i < companies.length-1 && <span style={{color:C.gold, fontSize:22, marginLeft:18, opacity:0.8}}>·</span>}
                    </div>
                  );
                })}
              </div>
            </div>
            {companiesNote && (
              <div style={{fontFamily:S.sans, fontSize:15, lineHeight:1.45, color:C.fgMuted, fontStyle:'italic', maxWidth:1100}}>{companiesNote}</div>
            )}
          </div>
        )}

        <div style={{position:'absolute', left:90, right:90, bottom:36, display:'flex', justifyContent:'space-between', alignItems:'center', fontFamily:S.sans, fontSize:12, letterSpacing:'0.18em', textTransform:'uppercase', color:'rgba(0,75,73,0.5)', paddingTop:10, borderTop:'1px solid rgba(0,75,73,0.1)'}}>
          <span>Helmsman Imports &nbsp;·&nbsp; Advisory Board &nbsp;·&nbsp; Internal</span>
          <span>{pageOf}</span>
        </div>
      </div>
    </section>
  );
}

const teal = C.teal;

function S12_Thanks() {
  const greetings = [
    {lang:'English',           phrase:'Thank you very much',          script:''},
    {lang:'Filipino · Tagalog', phrase:'Maraming salamat po',          script:''},
    {lang:'French',             phrase:'Merci beaucoup',               script:''},
    {lang:'Hindi',              phrase:'Bahut bahut dhanyavaad',       script:'बहुत बहुत धन्यवाद'},
    {lang:'Urdu',               phrase:'Bahut bahut shukriya',         script:'بہت بہت شکریہ'},
    {lang:'Irish · Gaeilge',    phrase:'Go raibh míle maith agat',     script:''},
  ];

  return (
    <section style={{width:'100%',height:'100%',background:C.goldSoft,color:'#1a2624',padding:'110px 140px',position:'relative',overflow:'hidden',boxSizing:'border-box',display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
      <svg viewBox="0 0 1920 1080" preserveAspectRatio="none"
           style={{position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none', opacity:0.5}}>
        <defs>
          <linearGradient id="thanksGold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={C.gold} stopOpacity="0"/>
            <stop offset="1" stopColor={C.gold} stopOpacity="0.55"/>
          </linearGradient>
        </defs>
        <circle cx="1700" cy="200" r="320" fill="none" stroke="url(#thanksGold)" strokeWidth="1.5"/>
        <circle cx="1700" cy="200" r="220" fill="none" stroke={C.gold} strokeOpacity="0.18" strokeWidth="1"/>
        <circle cx="1700" cy="200" r="120" fill="none" stroke={C.gold} strokeOpacity="0.12" strokeWidth="1"/>
      </svg>

      <div style={{position:'relative', display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
        <img src={resources.logoHoriz} style={{height:56, width:'auto', objectFit:'contain'}} alt="Helmsman"/>
        <div style={{fontFamily:S.sans, fontSize:14, letterSpacing:'0.28em', textTransform:'uppercase', color:'#7a6528'}}>Thank you · 11 / 12</div>
      </div>

      <div style={{position:'relative', maxWidth:1500}}>
        <h2 style={{fontFamily:S.serif, fontSize:120, lineHeight:0.95, fontWeight:600, letterSpacing:'-0.025em', margin:'0 0 64px', color:C.teal}}>
          From me, in all of our languages.
        </h2>
        <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', columnGap:64, rowGap:44, maxWidth:1640}}>
          {greetings.map((g)=>(
            <div key={g.lang} style={{paddingTop:22, borderTop:`2px solid ${C.gold}`}}>
              <div style={{fontFamily:S.sans, fontSize:13, letterSpacing:'0.28em', textTransform:'uppercase', color:'#7a6528', marginBottom:14}}>{g.lang}</div>
              <div style={{fontFamily:S.serif, fontSize:38, lineHeight:1.15, color:C.teal, fontWeight:600, letterSpacing:'-0.01em'}}>{g.phrase}</div>
              {g.script && (
                <div style={{fontFamily:'Noto Sans, system-ui, sans-serif', fontSize:30, lineHeight:1.3, color:C.fgMuted, marginTop:10}}>{g.script}</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div style={{position:'relative', display:'flex', flexDirection:'column', gap:24, borderTop:`1px solid rgba(0,75,73,0.18)`, paddingTop:28}}>
        <div style={{display:'flex', alignItems:'baseline', gap:24, flexWrap:'wrap'}}>
          <div style={{fontFamily:S.sans, fontSize:22, letterSpacing:'0.3em', textTransform:'uppercase', color:C.bronze, fontWeight:600}}>P.S. —</div>
          <div style={{fontFamily:S.serif, fontSize:52, fontStyle:'italic', color:C.teal, letterSpacing:'-0.015em', lineHeight:1.1, fontWeight:500}}>
            one more slide — i think you'll want to see this →
          </div>
        </div>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-end'}}>
          <div style={{fontFamily:S.serif, fontSize:36, color:C.teal, fontStyle:'italic', fontWeight:500, letterSpacing:'-0.01em'}}>— Jeff</div>
          <div style={{textAlign:'right', fontFamily:S.sans, fontSize:15, color:C.fgMuted, lineHeight:1.55, letterSpacing:'0.04em'}}>
            Helmsman Imports &nbsp;·&nbsp; Long Island City, NY &nbsp;·&nbsp; April 2026
          </div>
        </div>
      </div>
    </section>
  );
}

function S13_DidntMakeIt() {
  const PS = S;
  const PC = C;
  return (
    <section style={{width:'100%',height:'100%',background:'#fff',color:'#000',position:'relative',boxSizing:'border-box',display:'grid',gridTemplateColumns:'820px 1fr', overflow:'hidden'}}>
      <div style={{position:'relative', background:PC.deepTeal, color:'#fff', display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:'80px 70px 80px', overflow:'hidden'}}>
        <div style={{position:'absolute', inset:0, overflow:'hidden'}}>
          <img src={resources.pNate} alt="Nate"
               style={{width:'100%', height:'100%', objectFit:'cover', objectPosition:'center 15%', filter:'saturate(0.75) contrast(1.05) brightness(0.92)', transform:'scale(1.05)', transformOrigin:'center top'}}/>
          <div style={{position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(0,51,50,0) 35%, rgba(0,51,50,0.55) 70%, rgba(0,51,50,0.95) 100%)'}}/>
          <div style={{position:'absolute', top:0, left:0, right:0, padding:'40px 70px', display:'flex', justifyContent:'space-between', alignItems:'center', background:'linear-gradient(180deg, rgba(0,51,50,0.85) 0%, rgba(0,51,50,0) 100%)'}}>
            <div style={{display:'flex', alignItems:'baseline', gap:18}}>
              <span style={{fontFamily:PS.serif, fontSize:42, fontWeight:600, color:PC.gold, letterSpacing:'-0.02em', lineHeight:1}}>08</span>
              <span style={{fontFamily:PS.sans, fontSize:14, letterSpacing:'0.28em', textTransform:'uppercase', color:'rgba(255,255,255,0.78)'}}>of 07 &nbsp;·&nbsp; advisor</span>
            </div>
            <span style={{fontFamily:PS.sans, fontSize:13, letterSpacing:'0.22em', textTransform:'uppercase', color:'rgba(255,255,255,0.72)', borderLeft:`2px solid ${PC.gold}`, paddingLeft:14, textAlign:'right', lineHeight:1.3}}>
              Out of scope
            </span>
          </div>
          <div style={{
            position:'absolute', top:260, left:'50%',
            transform:'translateX(-50%) rotate(-10deg)',
            border:'8px solid #c83232', color:'#c83232',
            padding:'16px 40px', fontFamily:PS.sans,
            fontSize:64, fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase',
            background:'rgba(255,255,255,0.04)',
            boxShadow:'inset 0 0 0 2px rgba(200,50,50,0.35)',
            textShadow:'0 0 2px rgba(200,50,50,0.35)',
            opacity:0.96, whiteSpace:'nowrap', pointerEvents:'none',
          }}>Disqualified</div>
        </div>

        <div style={{position:'relative'}}>
          <div style={{borderTop:`3px solid ${PC.gold}`, width:90, marginBottom:24}}/>
          <h2 style={{fontFamily:PS.serif, fontSize:104, lineHeight:0.9, fontWeight:600, letterSpacing:'-0.03em', margin:'0 0 18px', color:'#fff'}}>
            Nate<br/>Casablanca
          </h2>
          <div style={{fontFamily:PS.sans, fontSize:22, lineHeight:1.5, color:'rgba(255,255,255,0.82)', maxWidth:660, fontStyle:'italic'}}>
            Chief Self-Appointment Officer (CSAO)<br/>
            Nate, Nate, &amp; Associates — Company<br/>
            <span style={{fontStyle:'normal', fontSize:18, color:'rgba(255,255,255,0.6)', letterSpacing:'0.02em'}}>Former Helmsman CSO · July 2024</span><br/>
            <span style={{fontStyle:'normal', fontSize:17, color:'rgba(255,255,255,0.55)', letterSpacing:'0.02em'}}>Preceded by <b style={{fontWeight:500, color:PC.gold}}>Janzen Eagler</b>, New CSO</span>
          </div>
        </div>
      </div>

      <div style={{padding:'70px 90px 180px', display:'flex', flexDirection:'column', gap:36, position:'relative', overflow:'hidden'}}>
        <div>
          <div style={{display:'flex', alignItems:'center', gap:14, marginBottom:18}}>
            <div style={{width:32, height:1, background:PC.bronze}}/>
            <div style={{fontFamily:PS.sans, fontSize:15, letterSpacing:'0.32em', textTransform:'uppercase', color:PC.bronze, fontWeight:500}}>Candidate file</div>
          </div>
          <h1 style={{fontFamily:PS.serif, fontSize:96, lineHeight:0.95, fontWeight:600, letterSpacing:'-0.025em', color:PC.deepTeal, margin:0}}>
            The one that didn't <span style={{color:'#c83232', fontStyle:'italic'}}>make it</span>.
          </h1>
        </div>

        <div style={{fontFamily:PS.sans, fontSize:26, lineHeight:1.5, color:'#1a2624', maxWidth:1000}}>
          Every company has one. Nate was there at the beginning and his contribution was <b style={{color:PC.teal,fontWeight:500}}>significant — historically speaking</b>. Fluent in <i>legalese</i>, bumped hard and got two seconds of credit for it, and held strong opinions on branding, marketing, and technology on the strength of <b style={{color:PC.teal,fontWeight:500}}>having read a book</b>
          <svg viewBox="0 0 40 32" style={{display:'inline-block', verticalAlign:'-6px', width:34, height:28, marginLeft:6, marginRight:2}}>
            <path d="M4 6 C 4 4, 6 3, 9 3 L 19 3 C 20 3, 20 4, 20 5 L 20 27 C 20 28, 19 28, 18 28 L 8 28 C 6 28, 4 27, 4 25 Z" fill="#d6e2df" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
            <path d="M36 6 C 36 4, 34 3, 31 3 L 21 3 C 20 3, 20 4, 20 5 L 20 27 C 20 28, 21 28, 22 28 L 32 28 C 34 28, 36 27, 36 25 Z" fill="#e7d3b8" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
            <line x1="8" y1="9" x2="17" y2="9" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="8" y1="13" x2="17" y2="13" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="8" y1="17" x2="15" y2="17" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="23" y1="9" x2="32" y2="9" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="23" y1="13" x2="32" y2="13" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="23" y1="17" x2="30" y2="17" stroke="#1a2624" strokeWidth="0.8" strokeLinecap="round"/>
            <line x1="20" y1="3" x2="20" y2="28" stroke="#1a2624" strokeWidth="1.2"/>
          </svg>
          . Self-credentialed HR expert. Would like to recommend you a book. Has already emailed it to you. Twice.
          <div style={{marginTop:22}}>
            Did, to his credit, build the <b style={{color:PC.teal,fontWeight:500}}>best Helmsman app system</b> — for grade-school students
            <span style={{display:'inline-block', verticalAlign:'1px', marginLeft:10, marginRight:2, fontFamily:'"Comic Sans MS", "Chalkboard SE", "Marker Felt", cursive', fontSize:22, fontWeight:700, color:'#e84a8a', transform:'rotate(-4deg)', letterSpacing:'0.02em', lineHeight:1}}>A+!</span>
            <svg viewBox="0 0 60 22" style={{display:'inline-block', verticalAlign:'-4px', width:56, height:20, marginLeft:2, marginRight:2}}>
              <path d="M2 14 Q 8 4, 14 12 T 26 10 T 38 13 T 52 8 L 58 12" fill="none" stroke="#3aa34a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="6" cy="18" r="1.6" fill="#f5c542"/>
              <circle cx="22" cy="4" r="1.6" fill="#3aa8ff"/>
              <circle cx="44" cy="18" r="1.6" fill="#e84a8a"/>
            </svg>
            . And despite an unbroken record of strategic missteps, remains quietly confident that he is the best, deserves the best, and is beloved by all — <i>especially</i> Charene and Tulip. <b style={{color:PC.teal,fontWeight:500}}>Self-declared CFO and Co-CEO</b> of Helmsman Imports and, most importantly, <b style={{color:PC.teal,fontWeight:500}}>mentor of Will</b>.
          </div>
        </div>

        <div style={{position:'absolute', left:90, right:90, bottom:72, paddingTop:16, borderTop:`2px solid ${PC.gold}`}}>
          <div style={{display:'flex', alignItems:'flex-end', justifyContent:'space-between', gap:20, marginBottom:14}}>
            <div style={{fontFamily:PS.sans, fontSize:14, letterSpacing:'0.3em', textTransform:'uppercase', color:'#7a6528', fontWeight:500}}>His positions</div>
            <div style={{display:'flex', alignItems:'baseline', gap:16}}>
              <div style={{fontFamily:PS.serif, fontSize:54, lineHeight:0.95, color:'#c83232', fontStyle:'italic', fontWeight:700, letterSpacing:'-0.02em'}}>"I'll be back."</div>
              <div style={{fontFamily:PS.sans, fontSize:12, letterSpacing:'0.28em', textTransform:'uppercase', color:'#7a6528', fontWeight:500}}>— Nate, probably</div>
            </div>
          </div>
          <div style={{display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:16}}>
            {[
              {role:'CEO', org:'Barhive', icon:'queenbee'},
              {role:'CEO', org:'Drayhorse', icon:'horse'},
              {role:'CEO', org:'Thirst Group', icon:'thirst'},
              {role:'CEO', org:'Showerless Group', icon:'shower'},
              {role:'Lawyer', org:'Whitehouse Law', icon:'scales'},
            ].map((p, i) => (
              <div key={i} style={{display:'flex', flexDirection:'column', alignItems:'center', padding:'12px 6px 10px', borderRadius:4, background:'#faf6ec', border:`1px solid ${PC.platinum}`}}>
                <div style={{height:64, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:6}}>
                  {p.icon === 'queenbee' && (
                    <svg viewBox="0 0 60 52" style={{width:64, height:56}}>
                      <path d="M20 10 L 24 4 L 28 10 L 30 2 L 32 10 L 36 4 L 40 10 L 40 15 L 20 15 Z" fill="#cfaf5b" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
                      <circle cx="24" cy="5" r="1.2" fill="#c83232"/><circle cx="30" cy="3" r="1.2" fill="#c83232"/><circle cx="36" cy="5" r="1.2" fill="#c83232"/>
                      <ellipse cx="18" cy="26" rx="8" ry="4.5" fill="#ffffff" fillOpacity="0.85" stroke="#1a2624" strokeWidth="1.1" transform="rotate(-22 18 26)"/>
                      <ellipse cx="42" cy="26" rx="8" ry="4.5" fill="#ffffff" fillOpacity="0.85" stroke="#1a2624" strokeWidth="1.1" transform="rotate(22 42 26)"/>
                      <ellipse cx="30" cy="32" rx="13" ry="10" fill="#f5c542" stroke="#1a2624" strokeWidth="1.4"/>
                      <path d="M24 23 Q 24 41, 24 41" stroke="#1a2624" strokeWidth="2" fill="none"/>
                      <path d="M30 22 Q 30 42, 30 42" stroke="#1a2624" strokeWidth="2" fill="none"/>
                      <path d="M36 23 Q 36 41, 36 41" stroke="#1a2624" strokeWidth="2" fill="none"/>
                      <circle cx="22" cy="30" r="1.4" fill="#1a2624"/>
                      <path d="M43 32 L 49 32" stroke="#1a2624" strokeWidth="1.6" strokeLinecap="round"/>
                    </svg>
                  )}
                  {p.icon === 'horse' && (
                    <svg viewBox="0 0 72 52" style={{width:72, height:54}}>
                      <rect x="42" y="24" width="22" height="14" fill="#e7d3b8" stroke="#1a2624" strokeWidth="1.3"/>
                      <line x1="46" y1="24" x2="46" y2="38" stroke="#1a2624" strokeWidth="0.9"/><line x1="52" y1="24" x2="52" y2="38" stroke="#1a2624" strokeWidth="0.9"/><line x1="58" y1="24" x2="58" y2="38" stroke="#1a2624" strokeWidth="0.9"/>
                      <circle cx="48" cy="42" r="4" fill="none" stroke="#1a2624" strokeWidth="1.4"/><circle cx="60" cy="42" r="4" fill="none" stroke="#1a2624" strokeWidth="1.4"/>
                      <line x1="42" y1="32" x2="36" y2="32" stroke="#1a2624" strokeWidth="1.3"/>
                      <path d="M14 30 L 10 32 L 10 38 L 14 38 L 16 34 L 28 34 L 30 38 L 34 38 L 34 32 L 30 30 L 24 28 Q 18 27, 14 30 Z" fill="#8a6a48" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
                      <path d="M10 32 L 6 22 L 4 14 L 8 12 L 12 18 L 14 26" fill="#8a6a48" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
                      <circle cx="6" cy="16" r="0.9" fill="#1a2624"/>
                      <line x1="16" y1="38" x2="16" y2="46" stroke="#1a2624" strokeWidth="1.8" strokeLinecap="round"/>
                      <line x1="22" y1="38" x2="22" y2="46" stroke="#1a2624" strokeWidth="1.8" strokeLinecap="round"/>
                      <line x1="28" y1="38" x2="28" y2="46" stroke="#1a2624" strokeWidth="1.8" strokeLinecap="round"/>
                      <line x1="32" y1="38" x2="32" y2="46" stroke="#1a2624" strokeWidth="1.8" strokeLinecap="round"/>
                    </svg>
                  )}
                  {p.icon === 'thirst' && (
                    <svg viewBox="0 0 56 56" style={{width:60, height:60}}>
                      <circle cx="22" cy="18" r="10" fill="#f5d9b8" stroke="#1a2624" strokeWidth="1.4"/>
                      <line x1="16" y1="15" x2="20" y2="19" stroke="#1a2624" strokeWidth="1.3" strokeLinecap="round"/><line x1="20" y1="15" x2="16" y2="19" stroke="#1a2624" strokeWidth="1.3" strokeLinecap="round"/>
                      <line x1="24" y1="15" x2="28" y2="19" stroke="#1a2624" strokeWidth="1.3" strokeLinecap="round"/><line x1="28" y1="15" x2="24" y2="19" stroke="#1a2624" strokeWidth="1.3" strokeLinecap="round"/>
                      <path d="M20 23 Q 22 28, 22 30 L 24 30 Q 24 28, 26 23 Z" fill="#e84a8a" stroke="#1a2624" strokeWidth="1.1" strokeLinejoin="round"/>
                      <path d="M12 30 L 32 30 L 30 44 L 14 44 Z" fill="#3f5a57" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
                      <path d="M40 28 L 44 28 L 43 40 L 41 40 Z" fill="#ffffff" fillOpacity="0.4" stroke="#1a2624" strokeWidth="1.3" strokeLinejoin="round"/>
                    </svg>
                  )}
                  {p.icon === 'shower' && (
                    <svg viewBox="0 0 48 60" style={{width:50, height:62}}>
                      <line x1="24" y1="4" x2="24" y2="18" stroke="#1a2624" strokeWidth="2.2" strokeLinecap="round"/>
                      <line x1="24" y1="4" x2="12" y2="4" stroke="#1a2624" strokeWidth="2.2" strokeLinecap="round"/>
                      <ellipse cx="24" cy="20" rx="15" ry="5" fill="#cfaf5b" stroke="#1a2624" strokeWidth="1.6"/>
                      <circle cx="15" cy="22" r="1.1" fill="#1a2624"/><circle cx="20" cy="23" r="1.1" fill="#1a2624"/>
                      <circle cx="24" cy="23.5" r="1.1" fill="#1a2624"/><circle cx="28" cy="23" r="1.1" fill="#1a2624"/><circle cx="33" cy="22" r="1.1" fill="#1a2624"/>
                      <line x1="14" y1="28" x2="12" y2="42" stroke="#3aa8ff" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3"/>
                      <line x1="19" y1="28" x2="18" y2="46" stroke="#3aa8ff" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3"/>
                      <line x1="24" y1="28" x2="24" y2="48" stroke="#3aa8ff" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3"/>
                      <line x1="29" y1="28" x2="30" y2="46" stroke="#3aa8ff" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3"/>
                      <line x1="34" y1="28" x2="36" y2="42" stroke="#3aa8ff" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3"/>
                    </svg>
                  )}
                  {p.icon === 'scales' && (
                    <svg viewBox="0 0 60 56" style={{width:62, height:58}}>
                      <rect x="22" y="46" width="16" height="4" fill="#1a2624"/>
                      <line x1="30" y1="10" x2="30" y2="46" stroke="#1a2624" strokeWidth="2"/>
                      <line x1="8" y1="14" x2="52" y2="14" stroke="#1a2624" strokeWidth="2" strokeLinecap="round"/>
                      <circle cx="30" cy="10" r="3" fill="#cfaf5b" stroke="#1a2624" strokeWidth="1.3"/>
                      <line x1="8" y1="14" x2="4" y2="22" stroke="#1a2624" strokeWidth="1.1"/><line x1="8" y1="14" x2="12" y2="22" stroke="#1a2624" strokeWidth="1.1"/>
                      <path d="M2 22 Q 8 30, 14 22 Z" fill="#e7d3b8" stroke="#1a2624" strokeWidth="1.4" strokeLinejoin="round"/>
                      <line x1="52" y1="14" x2="48" y2="22" stroke="#1a2624" strokeWidth="1.1"/><line x1="52" y1="14" x2="56" y2="22" stroke="#1a2624" strokeWidth="1.1"/>
                      <path d="M46 22 Q 52 30, 58 22 Z" fill="#e7d3b8" stroke="#1a2624" strokeWidth="1.4" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                <div style={{fontFamily:PS.serif, fontSize:22, color:PC.teal, fontWeight:600, letterSpacing:'-0.01em', lineHeight:1}}>{p.role}</div>
                <div style={{fontFamily:PS.sans, fontSize:13, color:PC.bronze, fontWeight:500, letterSpacing:'0.04em', textTransform:'uppercase', marginTop:4, textAlign:'center'}}>{p.org}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{position:'absolute', left:90, right:90, bottom:36, display:'flex', justifyContent:'space-between', alignItems:'center', fontFamily:PS.sans, fontSize:12, letterSpacing:'0.18em', textTransform:'uppercase', color:'rgba(0,75,73,0.5)', paddingTop:10, borderTop:'1px solid rgba(0,75,73,0.1)'}}>
          <span>Helmsman Imports &nbsp;·&nbsp; Advisory Board &nbsp;·&nbsp; Internal</span>
          <span>12 / 12</span>
        </div>
      </div>
    </section>
  );
}

const SLIDES = [
  { id: 's-01', label: '01 Title', component: S01_Title },
  { id: 's-02', label: '02 Letter from Jeff', component: S02_Letter },
  { id: 's-03', label: '03 Before you meet them', component: S03_Framing },
  {
    id: 's-04', label: '04 John Trainer',
    component: () => <PersonSlide
      index={1} of={7} pageOf="04 / 12"
      lane="Three-tier distribution"
      name="John Trainer"
      title="Managing Director, Paradise Spirits. Former EVP Managing Director, Southern Glazer's Wine & Spirits."
      photo={resources.pJohn}
      why={<>John has spent his entire career running the U.S. three-tier alcohol distribution system from the inside, at the very top. He spent <b style={{color:C.teal,fontWeight:500}}>a decade at Diageo</b> (Smirnoff, Johnnie Walker, Tanqueray, Captain Morgan), then <b style={{color:C.teal,fontWeight:500}}>eight years at Pernod Ricard USA</b> (Absolut, Jameson, Malibu) as VP/GM of Illinois and Regional Director of New York. He then crossed to the distributor side as <b style={{color:C.teal,fontWeight:500}}>EVP Managing Director at Southern Glazer's</b>, the largest alcohol distributor in North America with $26B+ in annual revenue. Today he runs Paradise Spirits. When a distributor tells us "no," John knows whether it's a real no or a posturing no, and he knows exactly who to call to change it.</>}
      bring={[
        <>Managing-Director-level relationships at every major distributor house</>,
        <>Supplier-side playbooks from Pernod and Diageo — what they actually do vs. what they claim</>,
        <>Rate card benchmarking + commercial terms fluency across the category</>,
      ]}
      companies={[['Diageo','$21B revenue'],['Pernod Ricard USA','$2.5B revenue'],["Southern Glazer's",'$26B revenue'],['Paradise Spirits','Founder-led']]}
      companiesNote={<>Diageo and Pernod Ricard are the two largest spirits suppliers in the world (Smirnoff, Johnnie Walker, Absolut, Jameson). Southern Glazer's is the largest U.S. alcohol distributor at $26B+ in revenue.</>}
    />,
  },
  {
    id: 's-05', label: '05 Maggie Lapcewich',
    component: () => <PersonSlide
      index={2} of={7} pageOf="05 / 12"
      lane="Supplier & distributor strategy"
      name="Maggie Lapcewich"
      title="Former President of Diageo Canada. Former EVP Chief Growth Officer, Breakthru Beverage. 35+ years on both sides of three-tier."
      photo={resources.pMaggie}
      why={<>Maggie has spent 35 years in beverage alcohol, and unusually, she has run things from both sides of the industry. As Diageo's <b style={{color:C.teal,fontWeight:500}}>Global Tequilas lead</b>, she ran <b style={{color:C.teal,fontWeight:500}}>Jose Cuervo and Don Julio</b>, two of the most recognizable spirits brands in the world. She then became <b style={{color:C.teal,fontWeight:500}}>President of Diageo Canada</b>, before crossing to the distributor side as <b style={{color:C.teal,fontWeight:500}}>EVP Chief Growth Officer at Breakthru Beverage</b>, the third-largest U.S. wine and spirits distributor. There, she led the merger integration between Wirtz and Charmer-Sunbelt, and launched <b style={{color:C.teal,fontWeight:500}}>BREAKTHRU NOW</b>, their B2B ordering platform. Maggie understands how a President reads a P&L, and how a distributor rep reads a work-with on a Tuesday morning.</>}
      bring={[
        <>President-level distributor strategy + commercial process design</>,
        <>B2B eCommerce craft — she built what distributors actually use, not what looks good in a demo</>,
        <>Global tequila playbook — directly relevant to Paladar and Ginebra</>,
      ]}
      companies={[['Diageo Canada','$21B parent'],['Breakthru Beverage','$6B revenue'],['Jose Cuervo','#1 tequila globally'],['Don Julio','$1B+ brand']]}
      companiesNote={<>Breakthru Beverage is the third-largest U.S. wine and spirits distributor. Jose Cuervo and Don Julio are two of the world's most recognized tequila brands, both owned by Diageo during her tenure as Global Tequilas lead.</>}
    />,
  },
  {
    id: 's-06', label: '06 Derek Dodge',
    component: () => <PersonSlide
      index={3} of={7} pageOf="06 / 12"
      lane="Beverage & CPG leadership"
      name="Derek Dodge"
      title="Former President & CEO, Hoya Vision Care US/LATAM ($542M P&L). Former SVP National Accounts, Dr Pepper Snapple ($2.5B revenue). Former CSO, Buzzballz International."
      photo={resources.pDerek}
      why={<>Derek is a serial CEO and chief commercial leader who has run more P&Ls than most founders will see in their careers. As <b style={{color:C.teal,fontWeight:500}}>SVP National Accounts at Dr Pepper Snapple Group</b>, he owned <b style={{color:C.teal,fontWeight:500}}>$2.5B in annual revenue</b>, including the <b style={{color:C.teal,fontWeight:500}}>Walmart and Sam's Club portfolio at $1.6B</b>, the single largest beverage account in North America. He went on to become <b style={{color:C.teal,fontWeight:500}}>President & CEO of Hoya Vision Care US/LATAM</b>, running a $542M global P&L, and as Chief Strategy Officer at Buzzballz International, he <b style={{color:C.teal,fontWeight:500}}>built their international business from scratch to $23M</b>. If you want to understand what operating at real scale actually looks like, Derek shows you.</>}
      bring={[
        <>Chain-account pitch craft at Walmart/Sam's-grade altitude</>,
        <>CFO-level P&L discipline and margin engineering for scale</>,
        <>International brand-entry playbook (highly relevant for our imported clients)</>,
      ]}
      companies={[['Keurig Dr Pepper','$15B revenue'],['Hoya Vision Care','$6B revenue'],['Buzzballz','~$500M acquisition'],['7UP & Snapple','Portfolio brands']]}
      companiesNote={<>Dr Pepper Snapple is one of the largest beverage companies in North America, owner of Dr Pepper, 7UP, Snapple, Mott's, and Canada Dry. Buzzballz is the canned-cocktail brand that scaled from a Texas garage to a Sazerac acquisition.</>}
    />,
  },
  {
    id: 's-07', label: '07 Kristina Marino',
    component: () => <PersonSlide
      index={4} of={7} pageOf="07 / 12"
      lane="Brand building & exits"
      name="Kristina Marino"
      title="Three-time exited beverage brand marketer. Mr Black (Diageo, 2022). Kombrewcha (AB InBev via ZX Ventures). Stolen Rum ($14M)."
      photo={resources.pKristina}
      why={<>Kristina has built and exited three spirits and beverage brands in the past decade, a rare feat in this industry. At <b style={{color:C.teal,fontWeight:500}}>Mr Black Spirits</b>, an Australian cold-brew coffee liqueur, she helped drive the brand to the <b style={{color:C.teal,fontWeight:500}}>#1 premium coffee spirit position in the U.S.</b> per Nielsen, before <b style={{color:C.teal,fontWeight:500}}>Diageo acquired it in 2022</b>. Before that, she helped scale <b style={{color:C.teal,fontWeight:500}}>Kombrewcha</b> through its acquisition by AB InBev's ZX Ventures, and led marketing at <b style={{color:C.teal,fontWeight:500}}>Stolen Rum</b> through its $14M raise. She knows exactly what a brand worth buying looks like, from positioning to depletion curves to the due-diligence room. She has lived the founder journey our client brands are on right now.</>}
      bring={[
        <>Modern spirits brand playbooks that actually move depletions</>,
        <>Exit-grade positioning and narrative work</>,
        <>Founder-to-founder fluency — she's been on the other side of our pitch</>,
      ]}
      companies={[['Mr Black Spirits','Diageo acquisition 2022'],['Kombrewcha','Early RTD exit'],['Stolen Rum','Challenger brand'],['Diageo','$21B revenue'],['AB InBev (ZX Ventures)','$59B parent']]}
      companiesNote={<>Mr Black is the Australian cold-brew coffee liqueur that became the #1 premium coffee spirit in the U.S. before Diageo's 2022 acquisition. ZX Ventures is AB InBev's startup investment and acquisition arm.</>}
    />,
  },
  {
    id: 's-08', label: '08 Taylor Foxman',
    component: () => <PersonSlide
      index={5} of={7} pageOf="08 / 12"
      lane="Industry network & PR"
      name="Taylor Foxman"
      title="Founder & CEO, The Industry Collective. Currently advising 100+ CEOs across beverage, CPG, food, and cannabis. 40 UNDER 40 honoree. Rolling Stone Culture Council."
      photo={resources.pTaylor}
      why={<>Taylor founded <b style={{color:C.teal,fontWeight:500}}>The Industry Collective</b>, a strategic advisory firm that currently advises 100+ CEOs across beverage, CPG, food, and cannabis. Her client roster includes some of the most successful beverage exits of the last five years: <b style={{color:C.teal,fontWeight:500}}>BeatBox</b> (acquired by AB InBev), <b style={{color:C.teal,fontWeight:500}}>Dirty Shirley</b> (acquired by Sazerac), and <b style={{color:C.teal,fontWeight:500}}>Speakeasy Co.</b> (acquired by Flaviar). She is a <b style={{color:C.teal,fontWeight:500}}>40 UNDER 40</b> honoree and sits on the Rolling Stone Culture Council. If there is a founder, journalist, or buyer worth knowing in this industry, Taylor either knows them already or can introduce us within a week.</>}
      bring={[
        <>Warm-path intros to founders actively seeking US infrastructure</>,
        <>Trade press pipeline — Shanken, Impact, Beverage Dynamics, The Drinks Business</>,
        <>PR strategy for Helmsman itself — awards, conferences, visibility plays</>,
      ]}
      companies={[['The Industry Collective','Founder'],['BeatBox','AB InBev acquisition'],['Dirty Shirley','Sazerac acquisition'],['Speakeasy Co.','DTC platform'],['Rolling Stone Culture Council','Member']]}
      companiesNote={<>BeatBox is the party-punch RTD brand acquired by AB InBev. Dirty Shirley is the canned cocktail acquired by Sazerac. Speakeasy Co. is the DTC alcohol-fulfillment platform acquired by Flaviar.</>}
    />,
  },
  {
    id: 's-09', label: '09 Mike Solow',
    component: () => <PersonSlide
      index={6} of={7} pageOf="09 / 12"
      lane="Capital & investments"
      name="Mike Solow"
      title="Co-Founder, 99 Proof Partners. Co-Founder, Cask Strength Asset Management. Co-Founder, OCTANE. Has advised 200+ beverage entrepreneurs."
      photo={resources.pMike}
      why={<>Mike has built three separate capital vehicles, each one purpose-built for the beverage alcohol industry. <b style={{color:C.teal,fontWeight:500}}>99 Proof Partners</b> is a family-office venture fund investing in early-stage spirits and beverage brands. <b style={{color:C.teal,fontWeight:500}}>Cask Strength Asset Management</b> is a debt facility providing working capital secured against aging spirits inventory. <b style={{color:C.teal,fontWeight:500}}>OCTANE</b> is a growth-capital advisory that helps brands raise their Series A and B rounds. He has personally advised <b style={{color:C.teal,fontWeight:500}}>200+ beverage entrepreneurs</b>. When a client brand asks us for an introduction to capital, Mike is the first call. And when Helmsman is ready to scale our own capital base, he is already inside the conversation.</>}
      bring={[
        <>Working-capital facility design for beverage alcohol</>,
        <>Beverage-specific family office network (99 Proof Partners LPs)</>,
        <>Strategic capital advisory for Helmsman's own growth journey</>,
      ]}
      companies={[['99 Proof Partners','Family-office fund'],['Cask Strength','Inventory-backed debt'],['OCTANE','Growth credit']]}
      companiesNote={<>99 Proof Partners is a family-office venture fund for early-stage spirits and beverage. Cask Strength is a debt facility secured against aging spirits inventory. OCTANE is a growth-capital advisory for Series A and B raises.</>}
    />,
  },
  {
    id: 's-10', label: '10 Buxton Layton',
    component: () => <PersonSlide
      index={7} of={7} pageOf="10 / 12"
      lane="Supplier-side & wine"
      name="Bucky Layton"
      title="Manager of Business Development, LUMINA — Ankaa Global Logistics (Miramar, FL). Fifth-generation member of the Wente winegrowing family."
      photo={resources.pBuxton}
      why={<>Bucky brings two perspectives no one else on this board has. First, he is <b style={{color:C.teal,fontWeight:500}}>currently Manager of Business Development at Ankaa Global Logistics</b>, the warehouse and logistics arm of Southern Glazer's Wine & Spirits, where he runs point on <b style={{color:C.teal,fontWeight:500}}>Project Lumina</b> out of Miramar, FL. His view of the distributor floor is current, not five years stale. Second, he is a <b style={{color:C.teal,fontWeight:500}}>fifth-generation member of the Wente family</b>, owners of Wente Vineyards — the oldest continuously family-owned winery in the U.S., founded in 1883.</>}
      bring={[
        <>Current SGWS/Ankaa field intel — how the largest U.S. distributor actually moves product</>,
        <>Wine-specific category depth most importers don't have</>,
        <>Multigenerational supplier-family perspective on brand craft</>,
      ]}
      companies={[["Ankaa Global Logistics",'SGWS logistics arm'],["Southern Glazer's",'$26B revenue'],['Wente Vineyards','142 yrs, family-owned']]}
      companiesNote={<>Ankaa Global Logistics is the warehouse and logistics arm of Southern Glazer's Wine & Spirits, the largest wine and spirits distributor in the U.S. Wente Vineyards (Livermore Valley, CA) is the oldest continuously family-owned winery in the country — 140+ years, five generations.</>}
    />,
  },
  { id: 's-12', label: '11 Thank you', component: S12_Thanks },
  { id: 's-13', label: '12 The one that didn\'t make it', component: S13_DidntMakeIt },
];

export default function AdvisoryBoardDesktop() {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const containerRef = useRef(null);
  const total = SLIDES.length;

  const goTo = React.useCallback((idx) => {
    const clamped = Math.max(0, Math.min(total - 1, idx));
    setCurrentSlide(clamped);
  }, [total]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === ' ' || e.key === 'PageDown') {
        e.preventDefault();
        setCurrentSlide(s => Math.min(total - 1, s + 1));
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        setCurrentSlide(s => Math.max(0, s - 1));
      }
      if (e.key === 'Escape') {
        window.history.back();
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [total]);

  const Slide = SLIDES[currentSlide].component;

  return (
    <div ref={containerRef} style={{ width: '100vw', height: '100vh', background: '#000', display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'fixed', inset: 0, zIndex: 1000 }}>
      <style>{`
        @font-face { font-family: "GT Walsheim"; src: url("${pub}/advisory-board/GTWalsheim-Regular.otf") format("opentype"); font-weight: 400; font-style: normal; font-display: swap; }
        @font-face { font-family: "GT Walsheim"; src: url("${pub}/advisory-board/GTWalsheim-Medium.otf") format("opentype"); font-weight: 500; font-style: normal; font-display: swap; }
        @font-face { font-family: "New Spirit"; src: url("${pub}/advisory-board/NewSpirit.otf") format("opentype"); font-weight: 400 600; font-style: normal; font-display: swap; }
      `}</style>

      {/* Slide container — fixed 1920×1080 scaled to fit */}
      <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%) scale(var(--deck-scale, 1))',
          transformOrigin: 'center center',
          width: 1920, height: 1080,
        }}
          ref={el => {
            if (!el) return;
            const updateScale = () => {
              const scaleX = window.innerWidth / 1920;
              const scaleY = window.innerHeight / 1080;
              el.style.setProperty('--deck-scale', String(Math.min(scaleX, scaleY)));
              el.style.transform = `translate(-50%, -50%) scale(${Math.min(scaleX, scaleY)})`;
            };
            updateScale();
            window.addEventListener('resize', updateScale);
          }}
        >
          <Slide />
        </div>
      </div>

      {/* Nav bar */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '10px 24px',
        background: 'rgba(0,0,0,0.72)',
        backdropFilter: 'blur(8px)',
        zIndex: 50,
        gap: 16,
      }}>
        <button onClick={() => window.history.back()} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '6px 14px', fontFamily: S.sans, fontSize: 12, letterSpacing: '0.18em', textTransform: 'uppercase', cursor: 'pointer', borderRadius: 3 }}>← Back</button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {SLIDES.map((_, i) => (
            <button key={i} onClick={() => goTo(i)} style={{ width: i === currentSlide ? 24 : 8, height: 4, background: i === currentSlide ? C.gold : 'rgba(255,255,255,0.3)', border: 'none', borderRadius: 2, cursor: 'pointer', padding: 0, transition: 'all 0.2s' }} />
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => goTo(currentSlide - 1)} disabled={currentSlide === 0} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '6px 14px', fontFamily: S.sans, fontSize: 12, cursor: 'pointer', borderRadius: 3, opacity: currentSlide === 0 ? 0.3 : 1 }}>←</button>
          <span style={{ fontFamily: S.sans, fontSize: 12, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.12em' }}>{String(currentSlide + 1).padStart(2,'0')} / {String(total).padStart(2,'0')}</span>
          <button onClick={() => goTo(currentSlide + 1)} disabled={currentSlide === total - 1} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '6px 14px', fontFamily: S.sans, fontSize: 12, cursor: 'pointer', borderRadius: 3, opacity: currentSlide === total - 1 ? 0.3 : 1 }}>→</button>
        </div>
      </div>
    </div>
  );
}
